module.exports = __webpack_public_path__ + "img/horizontal_4_3_6000.b8007862.png";